<template>
  <div>
  <div :class="classes">
    <label :class="classesLabel">{{label}} </label>
    <div class="input-group__input" :style="`height: ${heightEditor}`">
      <div id="htmlValueEditor"></div>
    </div>
    <div v-if="hint" class="input-group__details"><div class="input-group__messages input-group__hint v-messages theme--light v-messages__wrapper v-messages__message">{{hint}}</div></div>
  </div>
</div>
</template>

<script>
  import {createEditor} from 'vueditor'
  import lang from '../vueditor/lang.ru.js'
  import macro from '../vueditor/macro.vue'

  import 'vueditor/dist/style/vueditor.min.css'

  const plugins = [
    {
      name: 'macro',
      element: {
        type: 'button',
        lang: {
          title: 'Макрос'
        },
        className: 'icon-macro'
      },
      component: macro
    }
  ]

  export default {
    name: 'v-html-field',
    props: {
      label: null,
      value: {
        type: String,
        default: ''
      },
      hint: null,
      heightEditor: {
        type: String,
        default: '150px'
      },
      readonly: {
        type: Boolean,
        default: false
      },
      macro: {
        type: Boolean,
        default: false
      }
    },
    data: function () {
      return {
        editor: null,
        isDirty: false,
        focused: false
      }
    },
    mounted () {
      if (!this.editor) {
        this.editor = this.genEditor()
      }
      this.setValue(this.value)
      this.setReadonly(this.readonly)
    },
    watch: {
      value: function (newValue) {
        this.setValue(newValue)
      },
      readonly: function (newValue) {
        this.setReadonly(newValue)
      }
    },
    computed: {
      classes () {
        return {
          // '.pa-0': this.solo,
          'input-group--solo': this.solo,
          'elevation-0': this.flat,
          'input-group': true,
          'input-group--text-field': true,
          'primary--text': this.focused,
          'input-group--focused': this.focused,
          'input-group--dirty': this.isDirty,
          'input-group--tab-focused': true
        }
      },
      classesLabel () {
        return {
          'caption': true,
          'v-label': true,
          'theme--light': !this.focused
        }
      }
    },
    methods: {
      setValue (value) {
        // console.log('setValue', value)
        this.editor && value && (this.editor.value = value)
      },
      setReadonly (value) {
        this.editor && (this.editor.readonly = value)
      },
      genEditor () {
        let config = {
          toolbar: [
            'fullscreen', 'sourceCode', 'undo', 'redo', '|',
            // 'element',
            'fontName', 'fontSize',
            'foreColor', 'backColor', 'divider', 'bold', 'italic', 'underline', 'strikeThrough',
            'link', 'unLink',
             // 'divider', 'subscript', 'superscript',
            'divider', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull',
            '|', 'indent', 'outdent', 'insertOrderedList', 'insertUnorderedList', '|',
            // 'picture', 'table', '|',
            // 'code',
            'removeFormat',
            '|', 'macro'
            // , 'markdown'
          ],
          shortbar: ['fullscreen', 'sourceCode', '|', 'foreColor', 'backColor', '|', 'bold', 'italic', '|', 'macro'],
          fontName: [
            { val: 'Arial' },
            { val: 'Times New Roman' },
            { val: 'Courier New' }
          ],
          headStyle: `
            <style>
              body {font-family: Arial;}
              pre {margin: 0; padding: 0.5rem;}
            </style>`,
          lang: lang
        }
        if (this.macro) {
          config.plugins = plugins
        }
        let inst = createEditor('#htmlValueEditor', config)
        inst.$on('input', () => {
          this.$emit('input', inst.getContent())
        })
        inst.$on('focus', () => {
          this.focused = true
        })
        inst.$on('blur', () => {
          this.focused = false
        })
        inst.value = null
        return inst
      }
    }
  }
</script>
<style type="text/css">
  .vueditor {
    border-top:  none;
    border-left:  none;
    border-right:  none;
  }
  .input-group--focused .vueditor {
    border-bottom-color: currentColor;
    border-bottom-width:  2px;
  }

</style>



// WEBPACK FOOTER //
// HtmlField.vue?48aa0867